// This redirect allowlist is hard-coded: a new consumer production domain must be added
// here by hand. The Next.js source derived these from CRM_URL/PAYMENTS_URL/OS_URL/SGS_APP_URL.
const allowedSuffixes = ['.socialgood.com', '.socialgoodsoftware.com', '.socialgoodsoftware.io', '.sgs.com'];
const allowedExactHosts = ['socialgood.com', 'socialgoodsoftware.com', 'socialgoodsoftware.io', 'sgs.com'];

function isAllowedHostname(hostname: string): boolean {
  let allowed = false;
  if (hostname === 'localhost' || hostname.startsWith('localhost:')) {
    allowed = true;
  } else if (allowedExactHosts.includes(hostname)) {
    allowed = true;
  } else {
    allowed = allowedSuffixes.some((suffix) => hostname.endsWith(suffix));
  }
  return allowed;
}

export function AssignWindowLocation(url: string): void {
  // Tiny indirection so jsdom-based tests can spy on the redirect without
  // colliding with the non-configurable window.location property.
  window.location.assign(url);
}

export function ValidateContinueUrl(rawUrl: string | null | undefined): string | null {
  let result: string | null = null;

  if (!rawUrl) {
    result = null;
  } else if (rawUrl.startsWith('/')) {
    result = rawUrl;
  } else {
    const hasHttps = rawUrl.startsWith('https://');
    const hasHttp = rawUrl.startsWith('http://');

    if (!hasHttps && !hasHttp) {
      result = null;
    } else {
      try {
        const parsed = new URL(rawUrl);
        const hostname = parsed.hostname;

        if (!hostname || hostname.trim() === '') {
          result = null;
        } else {
          const isLocalhost = hostname === 'localhost' || hostname.startsWith('localhost:');
          const isSgsBare = hostname === 'sgs.com' || hostname.endsWith('.sgs.com');

          if (hasHttp && !isLocalhost && !isSgsBare) {
            result = null;
          } else if (isAllowedHostname(hostname)) {
            result = parsed.toString();
          } else {
            result = null;
          }
        }
      } catch {
        result = null;
      }
    }
  }

  return result;
}
